import { tokenRefresher } from '@/lib/auth/TokenRefresher';

import { restApi } from '../../client';
import { replacePathVariables } from './utils/replacePathVariables';

export const deleteRequest = async <TResponse>(
  path: string,
  pathVariables?: unknown,
  queryParams?: unknown,
  signal?: AbortSignal,
): Promise<TResponse> => {
  const pathWithVariables = replacePathVariables(path, pathVariables);

  await tokenRefresher.checkToken();

  return new Promise((resolve, reject) => {
    restApi
      .delete(pathWithVariables, { params: queryParams, signal })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
